import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { SearchBar } from "../Dashboard-Seller/MyListings/components/SearchBar";
import { ParentStepper } from "../components/ParentStepper";
import { Modal } from "react-bootstrap";
import apiClient from "../api/apiClient";
import { handleErrors } from "../modules/handleErrors";
import LoadingSpinner from "../components/LoadingSpinner";
import InfiniteScroll from "../components/InfiniteScroll";
import { useInfiniteScroll } from "../hooks/useInfiniteScroll";
import { toast } from "react-toastify";
import { Truncate } from "@re-dev/react-truncate";
import NotFound from "../components/NotFound";

const PAGE_SIZE = 12;

const MockupsListing = () => {
  const [searchInput, setSearchInput] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const [editlistdata, seteditlistdata] = useState();
  const [mocko_id, setMocko_id] = useState(null);
  const [show, setShow] = useState(false);
  const modalClose = () => setShow(false);

  const fetchListingsPage = useCallback(
    async (page) => {
      const params = new URLSearchParams();
      if (appliedSearch) params.append("title", appliedSearch);
      params.append("page", page);
      params.append("page_size", String(PAGE_SIZE));
      return apiClient.get(`/listings/?${params.toString()}`);
    },
    [appliedSearch],
  );

  const {
    data: FeaturedMockups,
    loading,
    hasMore,
    loadMore,
    refetch,
  } = useInfiniteScroll(fetchListingsPage, [appliedSearch], PAGE_SIZE);

  const ModalForm = () => {
    return (
      <Modal
        show={show}
        onHide={modalClose}
        dialogClassName="stepper-modal"
        centered
      >
        <Modal.Body
          style={{
            padding: "0px",
            height: "95vh",
            overflowY: "auto",
            background: "#FDFAF1",
            borderRadius: "6px",
          }}
        >
          <ParentStepper
            editlistdata={editlistdata}
            onHide={modalClose}
            fetchFeaturedMockups={refetch}
            mocko_id={mocko_id}
          />
        </Modal.Body>
      </Modal>
    );
  };

  const showInitialSpinner = loading && FeaturedMockups.length === 0;

  return (
    <>
      <div>
        <div className="container">
          <div className="top-section d-flex pt-3  flex-wrap gap-3 justify-content-between">
            <h2 className=" mb-3" style={{ color: "#000000e6" }}>
              My Listings
            </h2>
            <div>
              <div className="ms-md-4 ms-0 ">
                <SearchBar
                  search={searchInput}
                  setSearch={setSearchInput}
                  appliedSearch={appliedSearch}
                  onApply={setAppliedSearch}
                />
              </div>
            </div>
          </div>

          <div className="my-listings mt-5 mb-5">
            {showInitialSpinner ? (
              <div className="d-flex justify-content-center mt-5">
                <LoadingSpinner color="#FF3E1F" />
              </div>
            ) : FeaturedMockups?.length > 0 ? (
              <InfiniteScroll
                onLoadMore={loadMore}
                hasMore={hasMore}
                loading={loading}
                loader={<LoadingSpinner color="#FF3E1F" />}
              >
                <div className="row">
                  {FeaturedMockups.map((item) => (
                    <div className=" col-6 col-lg-3 mb-4" key={item.id}>
                        <div className="listing-card card shadow p-2 h-100">
                          <div className="listing-img overflow-hidden ">
                            <Link
                              to={`/mockup?id=${item?.id}`}
                              className="card-img-wrapper position-relative "
                            >
                              <div className="" style={{ width: "18rem" }}>
                                <img
                                  src={
                                    item?.use_main_file_as_thumbnail
                                      ? item?.compressed_file
                                      : item?.thumbnails?.[0]?.image
                                  }
                                  className="card-img-top "
                                  alt="Product 1"
                                  style={{
                                    width: "100%",
                                    height: "220px",
                                    borderTopRightRadius: "30px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                  }}
                                />
                              </div>
                            </Link>
                          </div>
                          <div
                            className="listing-content pt-2 "
                            style={{ minHeight: "110px" }}
                          >
                            <h6 className="testelips fw-bold">{item?.title}</h6>
                            <Truncate style={{ fontSize: "16px" }} lines={2}>
                              {item?.short_description}
                            </Truncate>
                          </div>
                          <div className="text-muted mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                      </div>
                  ))}
                </div>
              </InfiniteScroll>
            ) : (
              <NotFound hasActiveSearch={Boolean(appliedSearch?.trim())} />
            )}
          </div>

          <ModalForm />
        </div>
      </div>
    </>
  );
};

export default MockupsListing;

const ModalFormRemove = ({
  showRemove,
  modalCloseRemove,
  mocko_id,
  fetchFeaturedMockups,
}) => {
  const [Loader, setLoader] = useState(false);
  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      setLoader(true);
      const response = await apiClient.delete(`/listings/${mocko_id}/`);
      setLoader(false);

      if (!response.ok) return handleErrors(response.data);
      toast.success("Product deleted successfully");
      fetchFeaturedMockups();
      modalCloseRemove();
    } catch (error) {}
  };

  return (
    <Modal
      show={showRemove}
      onHide={modalCloseRemove}
      dialogClassName="alert-modal"
      centered
    >
      <Modal.Body
        style={{
          padding: "40px 30px",
          background: "#F8D4B7",
          borderTopRightRadius: "24px",
          borderBottomLeftRadius: "24px",
        }}
      >
        <section className="text-center">
          <p>Are you sure you want to delete?</p>
          <div>
            <button
              disabled={Loader}
              className="btn grey-btn mb-3 px-5"
              style={{
                width: "190px",
                paddingTop: "8px",
                paddingBottom: "8px !important",
              }}
              onClick={handleRegister}
            >
              {Loader ? "I'm Sure..." : "I'm Sure"}
            </button>
          </div>

          <div>
            <button
              className="btn bg-white px-5"
              style={{ width: "190px", border: "2px solid #000" }}
              onClick={modalCloseRemove}
            >
              Cancel
            </button>
          </div>
        </section>
      </Modal.Body>
    </Modal>
  );
};
